// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"106216aa","150":"6e6ff2e6","404":"2cb3a753","483":"b2c29410","638":"ce173628","797":"f74d5aed"}[chunkId] + ".chunk.js";
};